// screens/LocationScreen.tsx
import { HorizontalContainer, VerticalContainer, VerticalSpacer } from "@components/General/Containers"
import { H2Title, Subtitle } from "@components/General/Titles"
import designSystem from "@styles/designSystem"
import { TextInput } from '@components/General/TextInput';
import { NormalButton } from '@components/General/Button';
import { QontactLogoPanel } from '@components/QontactLogoPanel';
import { useLocationScreenViewModel } from '../view-models/LocationScreenViewModel';
import { ErrorText } from "@components/General/Texts";
import { useEffect } from "react";

export const LocationScreen: React.FC = () => {
    const {
        locationName,
        locationNameError,
        address,
        addressError,
        isLoading,
        isCreating,
        mapRef,
        serviceError,
        setLocationName,
        setAddress,
        handleSubmit,
        viewDidAppear,
    } = useLocationScreenViewModel();

    // viewDidAppear - runs only once when component first mounts
    useEffect(() => {
        viewDidAppear()
    }, []) // Empty dependency array ensures this runs only once
    
    return (
        <HorizontalContainer 
            gap={designSystem.gapNone}
            height={'100%'}
        >
            <VerticalContainer 
                maxWidth={'50%'} 
                height={'100%'}
            >
                <QontactLogoPanel/>
            </VerticalContainer>
            
            <VerticalContainer 
                maxWidth={'50%'} 
                alignment={'center'}
                backgroundColor={designSystem.colorBackgroundGray3}
            >
                <VerticalSpacer/>
                <VerticalContainer width={'600px'}>
                    <VerticalContainer gap={designSystem.gapNone}>
                        <H2Title text={"En donde estás?".localized()}/>
                        <Subtitle text={"Para que puedas probar realizar una fichada usando Qontact, necesitamos saber en dónde estás.".localized()}/>
                    </VerticalContainer>

                    <TextInput
                        label={"Dale un nombre al lugar donde te encontras".localized()}
                        placeholder={"Oficina central".localized()}
                        onChange={setLocationName}
                        value={locationName}
                        error={locationNameError}
                        onEnterPress={handleSubmit}
                    />

                    <TextInput
                        label={"Dirección".localized()}
                        placeholder={"Calle 123, San Isidro, provincia de Buenos Aires".localized()}
                        onChange={setAddress}
                        value={address}
                        error={addressError}
                        onEnterPress={handleSubmit}
                    />
                    <VerticalContainer>
                        <div 
                            ref={mapRef}
                            style={{
                                width: '100%',
                                height: '300px',
                                borderRadius: '8px',
                                backgroundColor: '#e5e7eb',
                            }}
                        />
                        {isLoading && (
                            <p style={{ color: designSystem.colorWarningText }}>
                                {"Obteniendo tu ubicación...".localized()}
                            </p>
                        )}
                        
                    </VerticalContainer>

                    <NormalButton 
                        text={"Continuar".localized()}
                        width={"300px"}
                        loading={isCreating}
                        onClick={handleSubmit} 
                    />
                    { serviceError && 
                        <ErrorText text={serviceError}/>
                    }
                </VerticalContainer>
                <VerticalSpacer/>
            </VerticalContainer>
        </HorizontalContainer>
    );
};